import React, {useState, useEffect} from "react";

import lbl from "../../../data/Labels.json";
import db from "../../../services/query";

import PrintHeader from "../common/PrintHeader";

import Img from "../../common/Img";

import Chart from "./_ReceiptChart";
import {
    findFinancePayment,
    formatPrintMoney,
    paymentField,
} from "../financePrintUtils";
import {
    ReceiptAmountIcon,
    ReceiptCalendarIcon,
    ReceiptDocIcon,
    ReceiptUserIcon,
} from "../teacher-salary-report/_ReceiptDetailIcons";

const StaffSalaryReceipt = (props) => {
    const {staff_id, receipt_id} = props.match.params;
    const [data, setData] = useState([]);
    const [payment, setPayment] = useState({});

    let printHeadTexts = [
        'معاونیت امور اداری و مالی',
        'مدیریت مالی'
    ];

    let title = 'سند پرداخت';

    useEffect(async () => {
        const ac = new AbortController();
        requestData();
        return () => ac.abort();
    }, []);

    const requestData = async () => {
        let query = `staff/${staff_id}/payments`;

        await db.getAll(query).then(({ data }) => {
            setData(data);
            const allPayments = data?.data?.[0]?.payments ?? [];
            const found = findFinancePayment(allPayments, receipt_id);
            if (found) setPayment(found);
        });
    };

    const paymentDate = paymentField(payment, "payment_date", "date");
    const paidBy = paymentField(
        payment,
        "paid_by_staff_name",
        "paid_by_staff_name_en",
        "paid_by_staff",
        "paid_by"
    );
    const refNo = paymentField(payment, "bank_ref_no", "reference");
    const paymentAmount = paymentField(payment, "amount");

    const detailRows = [
        { label: 'تاریخ', value: paymentDate, Icon: ReceiptCalendarIcon },
        { label: 'پرداخت کننده', value: paidBy, Icon: ReceiptUserIcon },
        { label: 'ريفرنس نمبر', value: refNo, Icon: ReceiptDocIcon },
        {
            label: 'مبلغ',
            value: paymentAmount !== '' ? formatPrintMoney(paymentAmount) : '',
            Icon: ReceiptAmountIcon,
            bold: true,
        },
    ];

    return (
        <main className="main-print-wrapper payment-receipt-print staff-salary-receipt-print">
            <PrintHeader
                title={title}
                subtitle={payment.half_year}
                date={' '}
                printHeadTexts={printHeadTexts}
                landscape
            />

            <div style={{display: "grid", gap: "10px", marginBottom: "5px"}}>
                <div className="print-finance-top-row" style={{display: "grid", gridTemplateColumns: "auto 70%", gap: "10px"}}>
                    <div className="report-summary-area white-background-with-border">
                        <Chart data={data}/>
                    </div>

                    <div className="white-background-with-border print-finance-profile-panel">
                        <div className="overall-summary">
                            <div className="wrapper">
                                <p>{lbl.OverallBalance}</p>
                                <h2 className="print-ltr-amount">{formatPrintMoney(data?.summary?.overall_balance)}</h2>
                            </div>
                        </div>
                        <div className="print-finance-profile-row">
                            <div className="std-profile rounded">
                                <div className="wrapper">
                                    <Img src={data?.summary?.staff_photo}/>
                                </div>
                            </div>
                            <div className="print-finance-profile-meta">
                                <div className="wrapper">
                                    <h3>{data?.summary?.staff_name}</h3>
                                    <p>{data?.summary?.staff_position}</p>
                                    <p>{data?.summary?.staff_phone}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="print-finance-details-row" style={{paddingTop: "20px", display: "grid", gridTemplateColumns: "60% auto", gap: "20px"}}>
                <div className="receipt-sub-card-container receipt-remark-wrap" style={{height: "100%"}}>
                    <div className="sub-card receipt-remark-card" style={{height: "100%", display: "grid", gridTemplateColumns: "1fr auto", alignItems: "center", columnGap: "12px"}}>
                        <p className="content content-rtl" style={{padding: "0 5px"}}>{payment?.remark ?? ''}</p>
                        <p className="label">{'توضيحات'}</p>
                    </div>
                </div>

                <div className="receipt-sub-card-container receipt-field-cards">
                    {detailRows.map(({ label, value, Icon, bold }) => (
                        <div key={label} className={`sub-card receipt-field-card${bold ? " bold" : ""}`}>
                            <span className="receipt-detail-icon" aria-hidden="true">
                                <Icon />
                            </span>
                            <p className="content">{value}</p>
                            <p className="label">{label}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div style={{display: "grid", gridTemplateColumns: "auto auto auto", paddingTop: "50px"}}>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء تایید کننده</p>
                        </div>
                    </div>
                </div>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء پرداخت کننده</p>
                        </div>
                    </div>
                </div>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء گیرنده</p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default StaffSalaryReceipt;
